import { render } from "./QuestVictory4.vue?vue&type=template&id=36f3f6e8"
import script from "./QuestVictory4.vue?vue&type=script&lang=js"
export * from "./QuestVictory4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questVictories/QuestVictory4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36f3f6e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36f3f6e8', __exports__)) {
    api.reload('36f3f6e8', __exports__)
  }
  
  module.hot.accept("./QuestVictory4.vue?vue&type=template&id=36f3f6e8", () => {
    api.rerender('36f3f6e8', render)
  })

}


export default __exports__